import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

import { injectSuggestionsSetsService } from '@core/services/suggestions-sets/suggestions-sets.service';

import {
  CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET,
  CartSuggestionCardsBlockDataSource,
  CartSuggestionCardsBlockViewModel,
} from './cart-suggestion-cards-block-view-model';

@Injectable()
export class CartSuggestionCardsBlockStoreDataSource implements CartSuggestionCardsBlockDataSource {
  private readonly suggestionsSet = inject(CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET);
  private readonly suggestionsResource = injectSuggestionsSetsService({
    suggestionSetId: this.suggestionsSet,
  }).productsToSuggestBySetQuery.selectSignal(this.suggestionsSet);

  private readonly vm = computed((): CartSuggestionCardsBlockViewModel => {
    const resource = this.suggestionsResource();
    return {
      suggestions: {
        hasValue: resource.hasValue,
        value: resource.value,
        isLoading: resource.isLoading,
      },
    };
  });

  readonly vm$ = toObservable(this.vm) as Observable<CartSuggestionCardsBlockViewModel>;
}
